module.exports = __webpack_public_path__ + "img/logo_payu.334a281d.svg";